import type { DOMOutputSpec, NodeSpec } from '@atlaskit/editor-prosemirror/model';

export const CONNECTOR_SOURCE_CHIP_NODE_NAME = 'connectorSourceChip';

export type ConnectorSourceChipAttrs = {
	source: string;
	display: string;
	iconUrl: string | null;
};

const getAttr = (dom: HTMLElement, attrName: string): string | undefined => {
	const value = dom.getAttribute(attrName);
	return value ?? undefined;
};

export const connectorSourceChipToDOM = (attrs: ConnectorSourceChipAttrs): DOMOutputSpec => [
	'span',
	{
		'data-connector-source-chip': 'true',
		'data-source': attrs.source,
		'data-display': attrs.display,
		...(attrs.iconUrl ? { 'data-icon-url': attrs.iconUrl } : {}),
	},
	attrs.display,
];

export const connectorSourceChipNodeSpec: NodeSpec = {
	inline: true,
	group: 'inline',
	atom: true,
	attrs: {
		source: { default: '' },
		display: { default: '' },
		iconUrl: { default: null },
	},
	parseDOM: [
		{
			tag: 'span[data-connector-source-chip]',
			getAttrs: (dom) => {
				if (!(dom instanceof HTMLElement)) {
					return false;
				}

				return {
					source: getAttr(dom, 'data-source') ?? '',
					display: getAttr(dom, 'data-display') ?? dom.textContent ?? '',
					iconUrl: getAttr(dom, 'data-icon-url'),
				};
			},
		},
	],
	toDOM: (node): DOMOutputSpec =>
		connectorSourceChipToDOM({
			source: node.attrs.source,
			display: node.attrs.display,
			iconUrl: node.attrs.iconUrl,
		}),
	leafText: (node) => node.attrs.display,
};
